import React from 'react';
import './Footer.css';
import LFimg from '../../Assets/footerlogo.png';

function Footer() {
  return (
    <div className='Footer'>
      <div className='Top_Footer'>
        <div className='Top_Footer1'>
            <h4>SUBSCRIBE</h4>
            <h2>TO OUR NEWSLETTER</h2>
        </div>
        <div className='Top_Footer2'>
            <input placeholder='      Enter your email address..' type="email" />
            <button>SUBSCRIBE</button>
        </div>
      </div>
      <div className="Last_Footer">
        <div className="LF1">
          <img src={LFimg} alt="" />
          <p>
          Sindh Testing Service (Pvt.) Ltd, (STSTM) is an independent, autonomous, and professional testing organisation conducts Entrance Tests, Recruitment Test, Examinations & Assessment Test in free and fair manner.
          </p>
          <span> <i className='fa fa-facebook'></i></span>
          <span> <i className='fa fa-twitter'></i></span>
          <span> <i className='fa fa-linkedin'></i></span>
        </div>
        <div className="LF2">
          <h3>GET IN TOUCH</h3>
          <a href="#">
            <i className='fa fa-phone'></i>
            +92-51-2741833, 021-34761617, 00304- <br />
             111-7-787 (U.A.N)
          </a> <br />
          <span>
            <i className='fa fa-whatsapp'></i>
            0311-1030004
          </span> <br />
          <span>
            <i className='fa fa-envelope'></i>
            info@sts.org
          </span> <br />
          <span>
            <i className='fa fa-globe'></i>
            www.sts.org.pk
          </span> <br />
          <span>
            <i className='fa fa-map-marker'></i>
            Office No 105, First Floor Riaz <br />
            acrade kuri double road islamabad
          </span>
        </div>
        <div className="LF3">
        <h3>USEFUL LINKS</h3>
         <a href="#">
          Home
         </a>
         <a href="#">
          About Us
         </a>
         <a href="#">
          Test & Products
         </a>
         <a href="#">
          All Projects
         </a>
        </div>
        <div className="LF4">
        <h3>HEAD OFFICE</h3>
          <span>
          <iframe
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13491395.117575822!2d77.96868!3d34.355628!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbf626ed64fa1%3A0x9f0feae03c4660e8!2sSindh%20Testing%20Service%20Pakistan%20(STS)!5e0!3m2!1sen!2sus!4v1690097327029!5m2!1sen!2sus"
    width="260"
    height="200"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
  ></iframe>
          </span>
        </div>
      </div>
    </div>
  )
}

export default Footer
